import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App.tsx";
import "./index.css";

// Set Cesium Ion token BEFORE any Cesium code loads
import * as Cesium from 'cesium';

import { setupMockApi } from './shared/api/mockInterceptor';
import { logger } from '@/shared/utils/logger';

// Initialize mock API interceptor only for development or an explicit mock
// build. In production the mock layer is never wired into the transport (A05).
if (import.meta.env.DEV || import.meta.env.VITE_USE_MOCK_API === 'true') {
  setupMockApi();
}

const token = import.meta.env.VITE_CESIUM_ION_TOKEN;
if (token) {
  Cesium.Ion.defaultAccessToken = token;
} else {
  Cesium.Ion.defaultAccessToken = '';
  if (import.meta.env.DEV) {
    logger.info('[Config] VITE_CESIUM_ION_TOKEN is not set. Defaulting to standard Cesium access.');
  }
}

createRoot(document.getElementById("root")!).render(
  <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
    <App />
  </BrowserRouter>
);
